import { Link, Stack, Typography } from "@mui/material"
import { teal } from "@mui/material/colors"
import React from "react"
import AsaasSeal from "../../../AsaasSeal"
import { Trans, useTranslation } from "react-i18next"

export interface ICheckoutFooter4 {
  tenantName?: string
  setOpenTermsPurchase: (value: boolean) => void
}

const CheckoutFooter4 = ({
  tenantName,
  setOpenTermsPurchase,
}: ICheckoutFooter4) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column" textAlign={"center"} spacing={2} sx={{ px: 2 }}>
      {tenantName && (
        <Typography
          variant="body2"
          fontSize="14"
          lineHeight="18px"
          sx={{
            mt: 1,
            color: "#767171",
          }}
        >
          {t("checkout.footer.processingOnBehalf", { tenant: tenantName ?? "" })}
        </Typography>
      )}

      <Typography
        variant="body2"
        fontSize="14"
        lineHeight="18px"
        sx={{
          color: "#767171",
          mb: 2,
        }}
      >
        <Trans
          i18nKey="checkout.footer.legal"
          components={{
            privacy: (
              <Link
                href="https://policies.google.com/privacy"
                sx={{
                  color: "#1C52BD",
                }}
              />
            ),
            terms: (
              <Link
                href="https://policies.google.com/terms"
                sx={{
                  color: "#1C52BD",
                }}
              />
            ),
            purchase: (
              <Link
                underline="hover"
                onClick={() => setOpenTermsPurchase(true)}
                sx={{
                  color: "#5D5E61",
                }}
              />
            ),
          }}
        />
      </Typography>

      <Typography
        variant="body2"
        textAlign={"center"}
        fontSize="14"
        sx={{
          color: "#5D5E61",
        }}
      >
        {t("checkout.footer.rights")}
      </Typography>
      <AsaasSeal />
    </Stack>
  )
}

export default CheckoutFooter4
